export default __webpack_public_path__ + "static/media/Edenred-EMP-banner-payment.d1fa3d78.jpg";